<template>
  <div class="layout-box">
        <div class="title" :class="$route.path === '/index'?'':''" v-if="!isMobile">
            <img src="../assets/img/logo.png" class="logo flex-0">
            <div class="menu d-flex flex-auto">
                    <div class="menu-item" v-for="item of menuList" :key="item.path" @click="routePush(item.path)">{{item.text}}</div>
                    <div class="menu-item" @click="routePush('/' + type +'job' + $store.state.searchText)" v-if="type && type.indexOf('recommend') !== -1">推荐岗位</div>
                    <div class="menu-item"><a class="link" href="https://www.putailai.com/" target="_blank">关于璞泰来</a></div>

                    <div class="flex-auto text-right">
                        <!-- <div class="menu-item" @click="routePush('/widely')">广投简历</div> -->
                    </div>
            </div>
        </div>
        <div class="title mobile_title" :class="$route.path === '/index'?'':''" v-else>
            <img src="../assets/img/logo.png" class="logo flex-0">
            <div class="mobile_menu">
                <van-popover v-model="showPopover" trigger="click" placement="bottom-end" :actions="menuList" @select="onMenuSelect">
                    <template #reference>
                        <van-icon name="wap-nav" color="#FFF" size="35" />
                    </template>
                </van-popover>
            </div>
        </div>
        <div class="main-container">
            <router-view v-slot="{ Component }">
                <transition name="router-fade" mode="out-in">
                    <component :is="Component" />
                </transition>
            </router-view>
        </div>
  </div>
</template>
<script>
export default {
    name: 'Layout',
    data() {
        return {
            menuList: [{ path: '/index', text: '首页' }, { path: '/job/social', text: '社会招聘' },
                { path: '/job/campus', text: '校园招聘' }, { path: '/job/worker', text: '工人招聘' }],
            type: this.$store.state.pageType,
            isMobile: false,
            showPopover: false
        };
    },
    created() {
        this.isMobile = !!this.is_mobile();
        if (this.type && this.type.indexOf('recommend') !== -1) {
            this.menuList = [{ path: '/index?type' + this.type, text: '首页' }];
            return;
        }
        // 根据是否存在有效类型来生成头部导航栏列表
        if (!this.type || ['social', 'campus', 'worker'].indexOf(this.type) === -1) {
            return;
        }

        this.menuList = [{ path: '/index?type' + this.type, text: '首页' },
            { path: '/' + this.type + '/job', text: this.type === 'social' ? '社会招聘' : this.type === 'campus' ? '校园招聘' : '工人招聘' }];
    },
    methods: {
        routePush(url) {
            if (url.indexOf(this.$route.path) !== -1) {
                return;
            }
            this.$router.push(this.isMobile ? '/m' + url : url);
        },
        is_mobile() {
            return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        },
        onMenuSelect(val) {
            this.routePush(val.path);
        }
    }
};
</script>

<style lang="scss" scoped>
.layout-box {
    height: 100%;
    position: relative;
}
.title {
    z-index: 1;
    height: 80px;
    padding: 0 120px;
    // background: #00003C;
    min-width: 960px;
    overflow: hidden;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    .logo {
        height: 40px;
        padding: 20px 0;
        -webkit-box-flex: 0 0 auto;
        -moz-box-flex: 0 0 auto;
        -webkit-flex: 0 0 auto;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        min-width: 120px;
    }
    .menu {
        padding: 0 0 0 60px;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        align-items: center;
        .menu-item {
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 2px;
            display: inline-block;
            color: #fff;
            margin-right: 60px;
            cursor: pointer;
            position: relative;
        }
        .menu-item::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -15px;
            background-color: #fff;
            width: 0px;
            height: 0px;
            -webkit-transition: all 0.8s;
            -o-transition: all 0.8s;
            -moz-transition: all 0.8s;
            transition: all 0.8s;
        }
        .menu-item:hover::after {
            width: 100%;
            height: 1px;
        }
    }
}
.link {
    color: #fff;
    text-decoration: none;
}
.main-container {
    margin: auto;
    height: 100%;
    width: 100%;
}
.dark.title .menu-item, .dark.title .menu-item .link {
    color: #00003C;
}
.dark.title .menu-item::after {
    background: #00003C;
}

.mobile_title {
    padding: 0 20px;
    // display: block;
    width: 100%;
    min-width: 100%;
    box-sizing: border-box;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -moz-box-pack: end;
    -webkit--moz-box-pack: end;
    box-pack: end;
}
.mobile_menu {
    // float: right;
    // height: 100%;
    margin: auto 0;
}
</style>
